/* import React, { useEffect, useState } from 'react';*/
/* import { useNavigate } from 'react-router-dom'; */
/* import { Dropdown } from 'react-bootstrap'; */
/* import ModalLogin from './ModalLogin';
import ModalRegister from './ModalRegister'; */

function Header() {
  return (
    <header>
      <nav className="navbar navbar-expand-lg" id="mainNavbar">
        <div className="container-fluid">
          <div className="logosMenu">
            <a className="EnlacesMenu" href="https://urosario.edu.co/" target="_blank" rel="noreferrer noopener">
              <img src="https://urosario.edu.co/sites/default/files/2024-03/logo-urosario.png" className="logosHeader logo_ur" alt="Logo Universidad del Rosario" />
            </a>
            <a className="EnlacesMenu" href="/">
              <img src="https://urosario.edu.co/sites/default/files/2024-05/logo-biblioteca-humana-v3.png" className="logosHeader logo_bh" alt="Logo Biblioteca Humana" />
            </a>
          </div>

        </div>
      </nav>
    </header>
  );
}

export default Header;
